import './tree.css';

import { MenuItem } from 'bz-core-controls/controls/next/menu';

import _ from 'lodash';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import File from './controls/file';
import Folder from './controls/folder';

@observer
class DocumentsTree extends React.Component {
  tree(directory) {
    if (!directory) {
      return [];
    }
    let files = directory.files || [];
    if (this.props.serverSorted === false) {
      files = _.orderBy(directory.files || [], this.props.fileSortProp, this.props.fileSortDir);
    }
    const contents = [
      (directory.folders || []).map((folder) => {
        let _props = Object.assign(
          {
            id: this.props.id,
            path: folder.path,
            childFolders: this.tree(folder),
            files: folder.files || [],
            existingFolders: directory.folders || []
          },
          folder,
          {
            onSelect: this.props.onSelect,
            selectedPath: this.props.selectedPath,
            onRunTemplate: this.props.onRunTemplate,
            existingFolders: directory.folders || []
          }
        );

        return React.createElement(this.props.FolderTemplate, _props);
      }),
      files.map((f) => {
        return React.createElement(
          this.props.FileTemplate,
          Object.assign(
            {
              onViewSms: this.props.onViewSms,
              onCloseMenu: this.props.onCloseMenu,
              onRunTemplate: this.props.onRunTemplate,
              id: this.props.id,
              existingFiles: directory.files,
              path: f.path,
              action: this.props.action,
              mode: this.props.mode,
              redirectId: this.props.redirectId,
              redirectMode: this.props.redirectMode,
              workflowId: this.props.workflowId
            },
            f,
            {
              onSelect: this.props.onSelect,
              selectedPath: this.props.selectedPath
            }
          )
        );
      })
    ];
    return contents;
  }

  render() {
    let { type, style, folder, includeBlank, additionalMenuItems } = this.props;
    const tree = this.tree(folder);
    let blankName = type.replace(/^[a-z]/gm, (x) => x.toUpperCase());
    if (type === 'multi') {
      let blank = null;

      if (!!includeBlank) {
        blank = (
          <li>
            <i className="fa fa-file-o" />
            <span onClick={this.onCreate}>{`New ${blankName}`}</span>
          </li>
        );
      }

      return (
        <ul className={this.props.treeClassName} style={this.props.style}>
          {blank}
          {this.tree(folder)}
        </ul>
      );
    }

    const items = [];

    if (!!additionalMenuItems && additionalMenuItems.length > 0) {
      items.addItems(additionalMenuItems);
    }

    if (includeBlank) {
      items.push(<MenuItem onClick={this.onCreate} primaryText={`New ${blankName}`} />);
    }
    items.push(tree);

    return <MenuItem primaryText={blankName} menuItems={items} style={style} />;
  }

  @action.bound
  onCreate(e) {
    e.preventDefault();
    e.stopPropagation();

    this.props.onCloseMenu();
    this.props.onRunTemplate();
  }
}
DocumentsTree.defaultProps = {
  folder: {
    files: [],
    folders: []
  },
  FolderTemplate: Folder,
  FileTemplate: File,
  action: 'view',
  mode: 'patients',
  type: 'multi',
  title: 'Letter',
  treeClassName: 'bz-file-tree',
  fileSortProp: 'modifiedDate',
  fileSortDir: 'desc',
  serverSorted: false,
  onCloseMenu: () => {},
  onRunTemplate: () => {}
};
export default DocumentsTree;
